<template>
    <QueryEvent
        v-if="eventId"
        #default="{ event, eventContentId }"
        :event-id="typeof eventId === 'string' ? parseInt(eventId, 10) : eventId"
    >
        <TemplatePanel
            v-if="event"
            class="event-detail"
        >
            <template #default>
                <!-- Hero -->
                <EventHero :event="event" />

                <!-- Quote -->
                <BaseSection
                    v-if="event.curatorQuote"
                    width="content-sm"
                    color-theme="light"
                >
                    <BaseTestimonial
                        :content="event.curatorQuote"
                        :image="event.curator?.featuredImage"
                        :author="event.curator?.name"
                        :title="event.curator?.sub_title"
                    />
                </BaseSection>

                <!-- Description -->
                <FlexibleSectionRichText
                    v-if="event.description"
                    color-theme="light"
                    :rich-text="getDescription(event.description)"
                />

                <QueryUpdates
                    v-if="eventContentId"
                    v-slot="{ entries }"
                    :event-content="[eventContentId]"
                >
                    <BaseSection
                        v-if="entries && entries.length > 0"
                        data-width="content-sm"
                        color-theme="light"
                    >
                        <ArticleCard :entry="entries[0]" />
                    </BaseSection>
                </QueryUpdates>

                <!-- Trailer -->
                <FlexibleSectionTheVideo
                    v-if="event.trailerUrl"
                    color-theme="light"
                    :video-url="event.trailerUrl"
                    :caption="getTrailerCaption(event)"
                />

                <EventRelationList
                    :artists="event.artists"
                    :venue="event.venue"
                    :production-house="event.productionHouse"
                />

                <EventCta :ctas="filterCtas(ctas, 'eventContent')" />
            </template>

            <template #related>
                <EventRelated :event="event" />
            </template>
        </TemplatePanel>
    </QueryEvent>
</template>

<script setup lang="ts">
defineProps<{
    eventId: string|number|null
}>();

const ctas = useCta();

const getDescription = (text: string) => {
    return `<h2>Over dit programma</h2>${text}`;
};

const getTrailerCaption = (event: EventDate) => {
    let caption = event.trailerCaption || '';

    if (event.trailerCredits && event.trailerCaption) {
        caption += ` - ${event.trailerCredits}`;
    }

    if (event.trailerCredits && !event.trailerCaption) {
        caption = event.trailerCredits;
    }

    return caption;
};
</script>

<style lang="less" src="./PageEvent.less" />
